export const getAddressTouchedValues = (touched) => {
  const touchedUnitNumber = touched.unitNumber;
  const touchedStreetNumber = touched.streetNumber;
  const touchedSuburb = touched.suburb;
  const touchedStreet = touched.street;
  const touchedState = touched.state;
  const touchedPostCode = touched.postCode;

  return {
    touchedUnitNumber,
    touchedStreetNumber,
    touchedSuburb,
    touchedStreet,
    touchedState,
    touchedPostCode,
  }
};

export const getAddressErrorValues = errors => {
  const errorUnitNumber = errors.unitNumber;
  const errorStreetNumber = errors.streetNumber;
  const errorSuburb = errors.suburb;
  const errorStreet = errors.street;
  const errorState = errors.state;
  const errorPostCode = errors.postCode;

  return {
    errorUnitNumber,
    errorStreetNumber,
    errorSuburb,
    errorStreet,
    errorState,
    errorPostCode,
  }
};